import React, { useCallback } from "react";

import { FilterTypeEnum } from "@/enum/filters";
import RadioFilter from "@/features/explore/filters/RadioFilter";
import { IMainFilterChildren } from "@/types/Filters";

import MultiCheckbox from "./MultiCheckbox";
import NestedMultiCheckbox from "./NestedMultiCheckbox";

interface ISelectedFilterItem {
    data: IMainFilterChildren
}
function SelectedFilterItem({ data }: ISelectedFilterItem) {
    const getFilter = useCallback(() => {
        switch (data.type) {
            case FilterTypeEnum.RADIO_SELECT:
                return <RadioFilter data={data} />;
            case FilterTypeEnum.MULTI_SELECT_CHECKBOX:
                return <MultiCheckbox data={data} />;
            case FilterTypeEnum.NESTED_MULTI_SELECT_CHECKBOX:
                return <NestedMultiCheckbox data={data} />;
            default:
                return null;
        }
    }, [data]);

    return (
        <div className='filterInnerWrap'>
            <div className='subHead mb16'>
                {data.tooltipText}
            </div>
            {getFilter()}
        </div>
    );
}

export default SelectedFilterItem;
